import React, { useEffect, useState } from 'react'
import Map from 'ol/Map.js';
import { Feature } from 'ol/index.js'
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import Overlay from 'ol/Overlay.js';
import View from 'ol/View.js';
import { Point } from 'ol/geom.js';
import { Vector as VectorSource } from 'ol/source.js';
import { Vector as VectorLayer } from 'ol/layer.js';
import MousePosition from 'ol/control/MousePosition.js';
import { createStringXY } from 'ol/coordinate.js';
import { defaults as defaultControls } from 'ol/control.js';
import { Style, Icon, Text, Fill, Stroke } from 'ol/style'
import 'ol/ol.css'
import MsgUtils from '../Tools/MsgUtils';
import marker from '../../assets/marcador.png'
const server = process.env.REACT_APP_SERVER;

function PrincipalMapaMotos() {
    const [listaMotos, setListaMotos] = useState([]);
    const [map, setMap] = useState(null);
    function getInformacion() {
        fetch(`${server}/mapaView/getLocationMoto`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: '990'
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.ok) {
                    setListaMotos(data.ok)
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function agregarZoom() {
        map.getLayers().getArray().slice().forEach(layer => {
            if (layer && layer.get('name') === 'punto') {
                map.removeLayer(layer);
            }
        });
        console.log(map.getAllLayers())
        listaMotos.map((item) => {
            var j = 0;
            const place = [item.ULT_GEO_LONGITUD, item.ULT_GEO_LATITUD];
            const point = new Point(place);
            const vector = new VectorLayer({
                name: 'punto',
                source: new VectorSource({
                    features: [new Feature(point)],
                })
            });
            var iconBlue = new Style({
                image: new Icon({
                    anchor: [0.5, 1],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    opacity: 1,
                    src: marker
                }),
                text: new Text({
                    text: item.IDENTIFICADOR,
                    scale: 1.2,
                    fill: new Fill({
                        color: "#fff"
                    }),
                    stroke: new Stroke({
                        color: "0",
                        width: 3
                    })
                })
            });
            vector.setStyle(iconBlue);
            map.addLayer(vector);
        })
    }
    const mousePositionControl = new MousePosition({
        coordinateFormat: createStringXY(4),
        projection: 'EPSG:4326',
        className: 'custom-mouse-position',
        target: document.getElementById('mouse-position'),
    });
    useEffect(() => {
        if (map == null) {
            const mapa = new Map({
                controls: defaultControls().extend([mousePositionControl]),
                layers: [
                    new TileLayer({
                        name: 'viewOrigin',
                        source: new OSM(),
                    }),
                ],
                target: 'mapaView',
                view: new View({
                    projection: 'EPSG:4326',
                    center: [-66.1, -17.3],
                    zoom: 11,
                }),
            });
            const popup = new Overlay({
                element: document.getElementById('popup'),
                positioning: 'bottom-center',
                stopEvent: false,
              });
            mapa.addOverlay(popup)
            setMap(mapa);
        }
        getInformacion()
        navigator.geolocation.getCurrentPosition(
            function (position) {
                console.log(position);
            },
            function (error) {
                console.log("error", error.messaje)
            })
    }, [])
    return (
        <div className='w-100'>
            <div id='popup'></div>
            <div className='w-100' id='mapaView' style={{ height: '80vh' }}></div>
            <div className='container-fluid'>
                <button className='btn btn-sm btn-primary' onClick={() => agregarZoom()}>Ver Motos</button>
            </div>
            <div className='mouse-position'></div>
        </div>
    )
}

export default PrincipalMapaMotos